import { render, staticRenderFns } from "./iconLanguage.vue?vue&type=template&id=52f5990a&scoped=true"
import script from "./iconLanguage.vue?vue&type=script&lang=js"
export * from "./iconLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5990a",
  null
  
)

export default component.exports